<template>
  <div class="cart-box">
    <div class="nb">
      <!-- 步骤条 -->
      <div class="cart-step">
        <ul>
          <li class="cart1"><i></i>购物车</li>
          <li class="cart2 oncart2"><i></i>确认订单</li>
          <li class="cart3 oncart3"><i></i>付款</li>
          <li class="cart4"><i></i>支付成功</li>
        </ul>
      </div>

      <!-- 收货人信息 -->
      <div class="add-deliver">
        <div class="cart-title">
          <h3><span>收货人信息</span></h3>
        </div>
        <el-row>
          <el-col :span="12">
            <div class="sh-address">
              <ul>
                <li class="default-add">
                  <div class="inner-infos">
                    <div class="addr-hd">
                      <span>{{orderInfo.storeOrderAddressDto.username}}</span>
                    </div>
                    <div class="addr-bd">
                      <span></span>
                      <span>{{orderInfo.storeOrderAddressDto.address}}{{orderInfo.storeOrderAddressDto.tel}}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="sh-address" style="height: 148px;">
              <ul>
                <div style="float: left;margin-top: 55px;">
                  <img src="/img/img/wxpay_native.png" style="width: 33px;height: 33px;vertical-align: middle;display: inline-block;margin-right: 9px;">
                  <a href="javascript:void(0);">使用微信扫码支付</a>
                </div>
                <div style="float: left; margin-top: 120px;margin-left: -120px;color: red;font-size: initial;">也可以联系管理员转账</div>
                <div id="qrcode" style="width: 146px; height: 146px; float: left;margin-left: 50px;"></div>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 商品信息 -->
      <div class="goods-infor">
        <div class="cart-title" style="margin-top: 166px;">
          <h3><span>商品信息</span></h3>
        </div>
        <div class="goods-table">
          <div class="goods-thead">
            <div class="col col1">商品</div>
            <div class="col col3">单价</div>
            <div class="col col4">数量</div>
            <div class="col col5">小计</div>
          </div>
          <div class="goods-tbody">
            <div class="goodinfor" v-for="(prod, index) in orderInfo.storeOrderCartDtos" :key="index">
              <div class="col col1 goods-title-pic">
                <router-link :to="'/pages/plateform/productDetail?productId=' + prod.productId" target="_blank">
                  <img :src="prod.coverPhoto" width="60" height="60">
                </router-link>
                <div class="goods-describ elli">
                  <p>
                    <router-link :to="'/pages/plateform/productDetail?productId=' + prod.productId" target="_blank">
                      {{prod.prodName}}
                    </router-link>
                  </p>
                  <p>{{prod.prodDesc}}</p>
                </div>
              </div>
              <div class="col col3 goods-price"> ￥{{prod.price}} </div>
              <div class="col col4 good-num"> {{prod.cartNum}} </div>
              <div class="col col5 orange-bold xiaoji" style="border-bottom: none;"> ￥{{prod.cartNum * prod.price}} </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 结算信息 -->
      <div class="style-zhifu">
        <div class="fare-result">
          <div class="cart-title">
            <h3><span>结算信息</span></h3>
          </div>
          <div class="result-box">
            <ul>
              <li class="first">
                <div class="calu-box">
                  <p class="slivergrey">
                    <span><b class="orange-bold">{{orderInfo.totalNum}}</b> 件商品，总计：</span>
                    <span class="orange-bold big">￥<b id="payAmount">{{orderInfo.totalPrice}}</b></span>
                  </p>
                  <p class="slivergrey">
                    <span>运费：</span>
                    <span class="txtmoney">￥<b id="expfee">0.00</b></span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { listStoreOrder, nativeQrcodePayment } from '@/api/plateform/payApi'

export default {
  name: 'Pay',
  data() {
    return {
      orderInfo: {
        appId: "",
        freightPrice: "",
        oId: "",
        orderId: "",
        personId: "",
        personName: "",
        records: 0,
        remark: "",
        stateName: "",
        storeOrderAddressDto: {},
        storeOrderCartDtos: []
      },
      timer: null,
      stopPolling: false
    }
  },
  created() {
    this.listOrders(1, 1)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    listOrders(page, rows) {
      const params = {
        page: page,
        row: rows,
        orderId: this.$route.query.orderId
      }
      
      listStoreOrder(params).then(res => {
        if (res.data.length === 0) {
          this.$message.error("订单号不正确，请正确使用")
        } else {
          this.orderInfo = res.data[0]
          if (this.orderInfo.state === "0") {
            this.$router.push("/pages/plateform/paySuccess?orderId=" + this.$route.query.orderId)
            return
          }
          this.caculTotalMount()
          this.getQrCode(this.orderInfo)
          this.startPolling(page, rows)
        }
      }).catch(err => {
        console.log('请求失败处理', err)
      })
    },
    getQrCode(order) {
      if (order.state !== "1") {
        this.$router.push("/pages/plateform/payResult?orderId=" + order.orderId)
      }
      
      const data = {
        orderId: order.orderId,
        money: order.totalPrice,
        name: order.remark
      }
      
      nativeQrcodePayment(data).then(res => {
        if (res.code === 0) {
          this.$message.success("请使用微信扫描二维码支付")
          this.viewQr(res.codeUrl)
          return
        }
        this.$message.error(res.msg)
      }).catch(err => {
        console.log('请求失败处理', err)
        this.$message.error(err)
      })
    },
    startPolling(page, rows) {
      this.timer = setInterval(() => {
        const params = {
          page: page,
          row: rows,
          orderId: this.$route.query.orderId
        }
        
        listStoreOrder(params).then(res => {
          if (res.data.length === 0) {
            this.$message.error("订单号不正确，请正确使用")
          } else {
            const order = res.data[0]
            if (order.state !== "1") {
              clearInterval(this.timer)
              this.$router.push("/pages/plateform/payResult?orderId=" + order.orderId)
              return
            }
          }
        }).catch(err => {
          clearInterval(this.timer)
          console.log('请求失败处理', err)
        })
      }, 5000)
    },
    viewQr(url) {
      document.getElementById("qrcode").innerHTML = ""
      new QRCode(document.getElementById("qrcode"), {
        text: url,
        width: 146,
        height: 146,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.L
      })
    },
    caculTotalMount() {
      let j = 0, k = 0
      this.orderInfo.storeOrderCartDtos.forEach(item => {
        if (!isNaN(item.cartNum) && !isNaN(item.price)) {
          j += parseFloat(item.cartNum) * parseFloat(item.price).toFixed(2)
          k += parseFloat(item.cartNum)
        } else {
          this.orderInfo.totalMount = "请输入正确的数字"
          this.orderInfo.totalNum = "请输入正确的数字"
          throw Error()
        }
      })
      this.orderInfo.totalMount = j.toFixed(2)
      this.orderInfo.totalNum = k
    }
  }
}
</script>

<style scoped>
.cart-box {
  width: 100%;
}
.nb {
  width: 100%;
}
.cart-step {
  margin-bottom: 20px;
}
.cart-step ul {
  display: flex;
  justify-content: space-between;
}
.cart-step li {
  list-style: none;
  position: relative;
  text-align: center;
}
.cart-title h3 {
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
.sh-address {
  border: 1px solid #eee;
  padding: 15px;
  margin-bottom: 20px;
}
.goods-table {
  border: 1px solid #eee;
  margin-top: 20px;
}
.goods-thead, .goodinfor {
  display: flex;
  padding: 10px;
  border-bottom: 1px solid #eee;
}
.col {
  flex: 1;
  text-align: center;
}
.col1 {
  flex: 3;
  text-align: left;
}
.orange-bold {
  color: #ff6700;
  font-weight: bold;
}
.big {
  font-size: 18px;
}
</style>